import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '../shared/shared.module'
import { AutoCompleteModule } from 'primeng/autocomplete'
import { InputTextModule } from 'primeng/inputtext'
import { DropdownModule } from 'primeng/dropdown'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ButtonModule } from 'primeng/button'
import { DialogModule } from 'primeng/dialog'
import { CheckboxModule } from 'primeng/checkbox'
import { TreeSelectModule } from 'primeng/treeselect'
import { TooltipModule } from 'primeng/tooltip'
import { ScrollingModule } from '@angular/cdk/scrolling'
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling'
import { OverlayPanelModule } from 'primeng/overlaypanel'
import { SelectButtonModule } from 'primeng/selectbutton'
import { InputNumberModule } from 'primeng/inputnumber'
import { MatIconModule } from '@angular/material/icon'
import { BrowserModule } from '@angular/platform-browser'
import { ProgressBarModule } from 'primeng/progressbar'
import { MatStepperModule } from '@angular/material/stepper'
import { MatRadioModule } from '@angular/material/radio'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatButtonModule } from '@angular/material/button'
import { MatExpansionModule } from '@angular/material/expansion'
import { GrowthToolkitLandingComponent } from './components/landing-page/landing-page.component'
import { NgApexchartsModule } from 'ng-apexcharts'
import { MatTooltipModule } from '@angular/material/tooltip'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SelectModule } from 'primeng/select'
import { ListboxModule } from 'primeng/listbox'
import { ProgressSpinnerModule } from 'primeng/progressspinner'
import { IconFieldModule } from 'primeng/iconfield'
import { InputIconModule } from 'primeng/inputicon'
import { InputSwitchModule } from 'primeng/inputswitch'
import { MarkdownModule } from 'ngx-markdown'
import { GrowthToolkitRegionalManagerSummaryPage } from './components/regional-manager-summary-page/regional-manager-summary-page.component'
import { GrowthToolkitRegionalManagerHospitalPage } from './components/regional-manager-hospital-page/regional-manager-hospital-page.component'
import { GrowthToolkitHospitalManagerDashboardPage } from './components/hospital-manager-dashboard-page/hospital-manager-dashboard-page.component'
import { GrowthToolkitDirectorSummaryPage } from './components/director-summary-page/director-summary-page.component'
import { GrowthToolkitActionItemExpandableRowComponent } from './components/action-item-expandable-row/action-item-expandable-row.component'
import { GrowthToolkitActionItemListComponent } from './components/action-item-list/action-item-list.component'

@NgModule({
   declarations: [
      GrowthToolkitLandingComponent,
      GrowthToolkitActionItemExpandableRowComponent,
      GrowthToolkitActionItemListComponent,

      GrowthToolkitDirectorSummaryPage,
      GrowthToolkitHospitalManagerDashboardPage,
      GrowthToolkitRegionalManagerHospitalPage,
      GrowthToolkitRegionalManagerSummaryPage,
   ],
   imports: [
      CommonModule,
      SharedModule,
      AutoCompleteModule,
      ButtonModule,
      CheckboxModule,
      DialogModule,
      FormsModule,
      DropdownModule,
      SelectModule,
      InputTextModule,
      TreeSelectModule,
      TooltipModule,
      ScrollingModule,
      CdkVirtualScrollViewport,
      OverlayPanelModule,
      InputNumberModule,
      SelectButtonModule,
      MatIconModule,
      BrowserModule,
      MatTooltipModule,
      ProgressBarModule,
      MatStepperModule,
      MatRadioModule,
      MatCheckboxModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      MatInputModule,
      MatButtonModule,
      MatExpansionModule,
      NgApexchartsModule,
      BrowserAnimationsModule,
      ListboxModule,
      ProgressSpinnerModule,
      IconFieldModule,
      InputIconModule,
      InputSwitchModule,
      MarkdownModule.forRoot(),
   ],
})
export class GrowthToolkitModule {}
